"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TabContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "nav-item__TabContainer",
  componentId: "sc-15eq05x-0"
})(["position:relative;overflow:hidden;cursor:pointer;", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme && theme.breakpointInts ? (0, _styledComponents.css)(["@media (max-width:", "px){&:first-child{padding-left:", "px;}&:last-child{padding-right:", "px;}}"], theme.breakpointInts[4], theme.spacings[0], theme.spacings[0]) : null;
});
var NavLink = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "nav-item__NavLink",
  componentId: "sc-15eq05x-1"
})(["text-decoration:none;color:", ";"], function (props) {
  return (0, _styles.colors)(props.color, props);
});
var defaultProps = {
  isActive: false
};
var propTypes = {
  /** isActive representing boolean value */
  isActive: _propTypes.bool,

  /** function for onTabClick */
  onTabClick: _propTypes.func,

  /** string value for path defines the section to scroll to */
  path: _propTypes.string.isRequired,

  /** string value for text defines the text for link */
  text: _propTypes.string.isRequired
};

var NavItem = function NavItem(_ref2) {
  var text = _ref2.text,
      isActive = _ref2.isActive,
      onTabClick = _ref2.onTabClick,
      path = _ref2.path;
  return /*#__PURE__*/_react["default"].createElement(TabContainer, {
    "data-test-id": "modules-nav-item",
    flex: "0 0 auto",
    px: 2
  }, /*#__PURE__*/_react["default"].createElement(NavLink, {
    color: isActive ? "title-black" : "body-grey",
    display: "inline-block",
    fontSize: 3,
    href: path,
    letterSpacing: "0.5px",
    onClick: onTabClick,
    tag: "a"
  }, text));
};

NavItem.defaultProps = defaultProps;
NavItem.propTypes = propTypes;
var _default = NavItem;
exports["default"] = _default;